module.exports = __webpack_public_path__ + "img/ch21_01_冬天空城.43861c2b.jpg";